module.exports = __webpack_public_path__ + "img/8_ward_800_closer.e84d2c2f.png";